<template>
  <ImgUpload
    ref="imgs"
    :file="tbForm[key]"
    @upload-success="(url) => onChange(url)"
    @del="() => onChange('')"
    :isSingle="true"
    v-bind="extraAttr"
  />
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload'

import storeMixins from '../store-mixins'

export default {
  components: {
    ImgUpload
  },
  mixins: [storeMixins],
  props: ['props'],
  computed: {
    key() {
      return this.props.name
    },
    extraAttr() {
      return this.props.extraAttr || {}
    }
  },
  methods: {
    onChange(v) {
      const newFormFields = {}
      newFormFields[this.key] = v
      this.updateTbForm(newFormFields)
      if (this.extraAttr._needLimit) {
        setTimeout(() => {
          this.$refs.imgs.elFormItem && this.$refs.imgs.elFormItem.elForm.validateField(this.$refs.imgs.elFormItem.prop)
        }, 800);
      }
    }
  },
  mounted() {
    const watcher = this.$watch('extraAttr', (v) => {
      if (v._needLimit && this.$refs.imgs) {
        console.log(this.$refs.imgs)
        this.$parent.rules.push({
          validator: async (rule, value, callback) => {
            let errMsg = await this.$refs.imgs.method_validImage()
            if (errMsg) {
                callback(new Error(errMsg));
            } else {
                callback();
            }
          }
        })
      }
      this.$nextTick(() => {
        watcher && watcher();
      })
    }, {
      immediate: true
    })
  }
}
</script>

<style>

</style>